exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a.provider-panel--1ekmIc4Bt0314Pp5m7xasy {\n  all: unset;\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: .75rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n  letter-spacing: .2px;\n  color: #373939;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\na.provider-panel--1ekmIc4Bt0314Pp5m7xasy:hover {\n  color: #373939;\n  text-decoration: none;\n}\n\na.provider-panel--1ekmIc4Bt0314Pp5m7xasy + .provider-panel--ZtVXZWbM3VgX1sWMv3au2 {\n  margin-top: .1875rem;\n  padding: 0 2rem 0 0;\n}\n", ""]);

// exports
exports.locals = {
	"addPracticeButton": "provider-panel--1ekmIc4Bt0314Pp5m7xasy",
	"addPracticeButton": "provider-panel--1ekmIc4Bt0314Pp5m7xasy",
	"fieldValue": "provider-panel--ZtVXZWbM3VgX1sWMv3au2",
	"fieldValue": "provider-panel--ZtVXZWbM3VgX1sWMv3au2"
};